import uploadshomesidebyside03imageimg_0052CroppedJpg from "$lib/data/generated/uploads/home/SideBySide 03/image/IMG_0052-cropped.jpg";

export const uploads = {
  "uploads/home/SideBySide 03/image/IMG_0052-cropped.jpg": uploadshomesidebyside03imageimg_0052CroppedJpg
};